import { useAuth } from "../../hooks/useAuth";
import { Navigate } from "react-router-dom";

export default function RoleAccess({ roles = [], element }) {
  const { user } = useAuth();
  return !roles.length || roles.includes(user?.role)
    ? element
    : <Navigate to="/error?msg=unauthorized access" replace />;
};
